import React, {PureComponent, Fragment} from 'react';
import Hammer from 'react-hammerjs';
import * as ReactGA from '../../GA';
import {Menu, MenuItem} from '../../atoms/Menu';
import EnhanceVisibilitySection from './EnhanceVisibilitySection';
import i18n from '../../locales/i18n';

import './EnhancedVisibility.css';

const SECTIONS = [
    {
        title: 'prizm.enhanced_visibility.mx.title',
        problem: 'prizm.enhanced_visibility.mx.problem',
        solution: 'prizm.enhanced_visibility.mx.solution',
        video: require('./prizm-MX.mp4'),
        poster: require('./prizm-MX-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.cricket.title',
        problem: 'prizm.enhanced_visibility.cricket.problem',
        solution: 'prizm.enhanced_visibility.cricket.solution',
        video: require('./prizm-cricket.mp4'),
        poster: require('./prizm-cricket-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.golfing.title',
        problem: 'prizm.enhanced_visibility.golfing.problem',
        solution: 'prizm.enhanced_visibility.golfing.solution',
        video: require('./prizm-golf.mp4'),
        poster: require('./prizm-golf-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.angling.title',
        problem: 'prizm.enhanced_visibility.angling.problem',
        solution: 'prizm.enhanced_visibility.angling.solution',
        video: require('./prizm-angling.mp4'),
        poster: require('./prizm-angling-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.snow.title',
        problem: 'prizm.enhanced_visibility.snow.problem',
        solution: 'prizm.enhanced_visibility.snow.solution',
        video: require('./prizm-snow.mp4'),
        poster: require('./prizm-snow-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.field.title',
        problem: 'prizm.enhanced_visibility.field.problem',
        solution: 'prizm.enhanced_visibility.field.solution',
        video: require('./prizm-field.mp4'),
        poster: require('./prizm-field-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.road.title',
        problem: 'prizm.enhanced_visibility.road.problem',
        solution: 'prizm.enhanced_visibility.road.solution',
        video: require('./prizm-road.mp4'),
        poster: require('./prizm-road-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.trail.title',
        problem: 'prizm.enhanced_visibility.trail.problem',
        solution: 'prizm.enhanced_visibility.trail.solution',
        video: require('./prizm-trail.mp4'),
        poster: require('./prizm-trail-poster.jpg'),
    },
    {
        title: 'prizm.enhanced_visibility.every_day.title',
        problem: 'prizm.enhanced_visibility.every_day.problem',
        solution: 'prizm.enhanced_visibility.every_day.solution',
        video: require('./prizm-daily.mp4'),
        poster: require('./prizm-daily-poster.jpg'),
    },
];

export default class EnhancedVisibility extends PureComponent {
    state = {
        section: 0,
    };

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/Prizm/EnhancedVisibility/${this.state.section}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/Prizm/EnhancedVisibility/${this.state.section}`
        );
    }

    changeSection = state => {
        this.setState({
            section: state,
        });
    };

    onSwipe = event => {
        let section;

        if (event.direction === 2) {
            // last section
            section = (this.state.section + 1) % SECTIONS.length;
        }
        if (event.direction === 4) {
            section =
                (this.state.section - 1 + SECTIONS.length) % SECTIONS.length;
        }
        if (section != null) {
            this.setState({section: section});
        }
    };

    render() {
        const currentSection = SECTIONS[this.state.section];

        const menuItems = SECTIONS.map((item, index) => (
            <MenuItem
                key={index}
                tag={item.title}
                onClick={() => this.changeSection(index)}
                active={this.state.section === index}
            />
        ));

        return (
            <Hammer onSwipe={this.onSwipe}>
                <article className="EnhancedVisibility">
                    <EnhanceVisibilitySection
                        currentSection={currentSection}
                        currentY={this.state.scroll}
                    />
                    <Menu>{menuItems}</Menu>
                </article>
            </Hammer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/prizm/EnhancedVisibility.js